export default {
  name: 'JoiningVideoCallDialog',
  props: {
    fullName: {
      type: String,
      required: true
    },
    meetingId: {
      type: String,
      required: true
    }
  },

  mixins: [],
  created() {
    this.show = true;
  },
  methods: {
    onClickJoin() {
      this.$emit('onClickAttemptJoinVideoCall');
    },
    onClickCancel() {
      this.$emit('onClickCancelJoinVideoCall');
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixin/JoiningVideoCallDialog.js